import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=4bc90ba2&scoped=true&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"
import style0 from "./Search.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Search.vue?vue&type=style&index=1&id=4bc90ba2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc90ba2",
  null
  
)

export default component.exports